import React from "react";
import DescriptionIcon from "@mui/icons-material/Description";

const MetadataIcon = ({...props}) => <DescriptionIcon {...props} />;

export default MetadataIcon;
